/**
 * MedicalExam.js
 *
 * @description :: A model definition.  Represents a database table/collection/etc.
 * @docs        :: https://sailsjs.com/docs/concepts/models-and-orm/models
 */

export default {

  // tableName: 'examenes_medicos',

  attributes: {

    //  ╔═╗╦═╗╦╔╦╗╦╔╦╗╦╦  ╦╔═╗╔═╗
    //  ╠═╝╠╦╝║║║║║ ║ ║╚╗╔╝║╣ ╚═╗
    //  ╩  ╩╚═╩╩ ╩╩ ╩ ╩ ╚╝ ╚═╝╚═╝

    date: {
      type: 'ref',
      columnType: 'date',
      required: true,
      // columnName: 'fecha'
    },

    comments: {
      type: 'string',
      columnType: 'text',
      allowNull: true,
      // columnName: 'comentarios'
    },

    //  ╔═╗╔╦╗╔╗ ╔═╗╔╦╗╔═╗
    //  ║╣ ║║║╠╩╗║╣  ║║╚═╗
    //  ╚═╝╩ ╩╚═╝╚═╝═╩╝╚═╝


    //  ╔═╗╔═╗╔═╗╔═╗╔═╗╦╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
    //  ╠═╣╚═╗╚═╗║ ║║  ║╠═╣ ║ ║║ ║║║║╚═╗
    //  ╩ ╩╚═╝╚═╝╚═╝╚═╝╩╩ ╩ ╩ ╩╚═╝╝╚╝╚═╝

    driver: {
      model: 'driver',
      required: true,
      // columnName: 'chofer_id'
    },

    type: {
      model: 'medicalexamtype',
      required: true,
      // columnName: 'tipo_examen_medico_id'
    },

  },

}


// WEBPACK FOOTER //
// ./src/models/MedicalExam.js